var App = App || {};

App.ComponentCarousalPromos = (function ($) {
    'use strict';

    function CarousalPromos() {

        $('.commercial-solutions .commercialSlider').each(function () {

            var carousel = $(this);

            if (carousel.hasClass('is-initialized')) {
                return;
            }

            var desktopVisible = parseFloat(
                carousel.attr('data-desktop-per-page')
            ) || 3.2;

            var tabletVisible = parseFloat(
                carousel.attr('data-tablet-per-page')
            ) || 3;

            var mobileVisible = parseFloat(
                carousel.attr('data-mobile-per-page')
            ) || 1;

            var gap = 24;

            function getVisibleCards() {
                var width = window.innerWidth;

                if (width <= 767) {
                    return mobileVisible;
                }

                if (width <= 991) {
                    return tabletVisible;
                }

                return desktopVisible;
            }

            function getFixedWidth() {
                var visibleCards = getVisibleCards();
                var carouselWidth = carousel.width();
                var gaps = Math.ceil(visibleCards) - 1;

                return (
                    carouselWidth - (gaps * gap)
                ) / visibleCards;
            }

            var splide = new Splide(carousel[0], {
                type: 'loop',
                fixedWidth: getFixedWidth(),
                perMove: 1,
                gap: gap + 'px',
                arrows: true,
                pagination: true
            });

            function moveControls() {
                var component = carousel.closest('.commercial-solutions');

                var controls = component.find(
                    '.commercial-slider-controls'
                );

                var arrows = carousel.find('.splide__arrows');
                var pagination = carousel.find('.splide__pagination');

                if (controls.length) {
                    controls.append(arrows);
                    controls.append(pagination);
                }
            }

            splide.on('mounted updated resized', function () {
                moveControls();
            });

            splide.mount();

            var resizeTimer;

            $(window).on('resize', function () {

                clearTimeout(resizeTimer);

                resizeTimer = setTimeout(function () {

                    splide.options = {
                        fixedWidth: getFixedWidth()
                    };

                    splide.refresh();

                    moveControls();

                }, 150);

            });
        });
    }

    return {
        CarousalPromos: CarousalPromos
    };

})(jQuery);

$(function () {
    App.ComponentCarousalPromos.CarousalPromos();
});